(function() {
    "use strict";

    var debug = false;
    var currentVariantId = null;

    // Tempo máximo esperando as transportadoras responderem (ms)
    var RATES_TIMEOUT = 30000;
    var RATES_POLL_INTERVAL = 800;

    function log(text) {
        if (debug) console.log(text);
    }

    var productSection = document.getElementsByClassName("frete-produto");
    if (!productSection.length) {
        log("Could not find the frete-produto element");
        return;
    }

    var isCartContext = productSection[0].closest('[data-cart-context="true"]');
    if (isCartContext) {
        log("Cart context detected, skipping shipping-calculator.js");
        return;
    }

    var productSelect = document.getElementById("product-variant-id");
    if (!productSelect) {
        log("Could not find the variant input element");
        return;
    }

    var shippingMessage = document.createElement("p");
    var shippingCountry = document.createElement("select");
    var shippingProvince = document.createElement("select");
    var shippingZip = document.createElement("input");
    var freteLista = document.createElement("div");
    var calculando = false;

    shippingMessage.classList.add("erros-fretes");
    shippingMessage.setAttribute("style", "display:none");
    freteLista.classList.add("listas-de-fretes");
    freteLista.setAttribute("style", "display:none");

    // Intercepta openMiniCart imediatamente e com polling como fallback
    function interceptarOpenMiniCart() {
        if (window.theme && window.theme.openMiniCart && !window.theme.__freteInterceptado) {
            var _original = window.theme.openMiniCart;
            window.theme.openMiniCart = function() {
                if (window.__calculandoFrete) {
                    log("openMiniCart bloqueado durante calculo de frete");
                    return;
                }
                _original.apply(this, arguments);
            };
            window.theme.__freteInterceptado = true;
            log("openMiniCart interceptado");
        }
    }

    // Tenta interceptar agora e a cada 100ms até conseguir (máx 5s)
    interceptarOpenMiniCart();
    var _tentativas = 0;
    var _interval = setInterval(function() {
        _tentativas++;
        interceptarOpenMiniCart();
        if (window.theme && window.theme.__freteInterceptado || _tentativas > 50) {
            clearInterval(_interval);
        }
    }, 100);

    var initFields = function() {
        shippingCountry.id = "pais-simulator";
        var countries = ["Brazil"];
        for (var i = 0; i < countries.length; i++) {
            shippingCountry.add(new Option(countries[i], countries[i], i === 0));
        }
        shippingCountry.name = "shipping_address[country]";

        shippingProvince.id = "estados-simulator";
        var provinces = ["Acre","Alagoas","Amapa","Amazonas","Bahia","Ceara","Distrito Federal","Espirito Santo","Goias","Maranhao","Mato Grosso","Mato Grosso do Sul","Minas Gerais","Para","Paraiba","Parana","Pernambuco","Piaui","Rio de Janeiro","Rio Grande do Norte","Rio Grande do Sul","Rondonia","Roraima","Santa Catarina","Sao Paulo","Sergipe","Tocantins"];
        for (var i = 0; i < provinces.length; i++) {
            shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
        }
        shippingProvince.name = "shipping_address[province]";

        shippingZip.type = "text";
        shippingZip.name = "shipping_address[zip]";
        shippingZip.className = "Form__Input cep-calculo-frete form-control";
        shippingZip.placeholder = "DIGITE SEU CEP";
        shippingZip.maxLength = 10;
        shippingZip.inputMode = "numeric";
        shippingZip.addEventListener("keydown", function(e) {
            if (e.key === "Enter") { e.preventDefault(); calculateShipping(); }
        });

        if (typeof $ !== 'undefined' && $.fn.mask) {
            $(shippingZip).mask("00.000-000");
        }

        var shippingCalcWrapper = document.querySelector(".shipping-calc-wrapper");
        if (!shippingCalcWrapper) {
            shippingCalcWrapper = document.createElement("div");
            shippingCalcWrapper.className = "shipping-calc-wrapper";
            productSection[0].appendChild(shippingCalcWrapper);
        }

        var formularioFrete = shippingCalcWrapper.querySelector(".formulario-frete");
        if (!formularioFrete) {
            formularioFrete = document.createElement("div");
            formularioFrete.className = "formulario-frete";
            shippingCalcWrapper.appendChild(formularioFrete);
        } else {
            formularioFrete.innerHTML = "";
        }

        var shippingCalcButton = document.createElement("a");
        shippingCalcButton.innerText = "Calcular";
        shippingCalcButton.className = "btn btn-underline button--primary button";
        shippingCalcButton.onclick = function() {
            calculateShipping();
        };

        formularioFrete.appendChild(shippingCountry);
        formularioFrete.appendChild(shippingProvince);
        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(shippingCalcButton);
        shippingCalcWrapper.appendChild(shippingMessage);
        shippingCalcWrapper.appendChild(freteLista);
    };

    var ufMap = {
        "AC":"Acre","AL":"Alagoas","AP":"Amapa","AM":"Amazonas",
        "BA":"Bahia","CE":"Ceara","DF":"Distrito Federal","ES":"Espirito Santo",
        "GO":"Goias","MA":"Maranhao","MT":"Mato Grosso","MS":"Mato Grosso do Sul",
        "MG":"Minas Gerais","PA":"Para","PB":"Paraiba","PR":"Parana",
        "PE":"Pernambuco","PI":"Piaui","RJ":"Rio de Janeiro","RN":"Rio Grande do Norte",
        "RS":"Rio Grande do Sul","RO":"Rondonia","RR":"Roraima","SC":"Santa Catarina",
        "SP":"Sao Paulo","SE":"Sergipe","TO":"Tocantins"
    };

    // Descobre a UF pelo CEP: ViaCEP e, se falhar, BrasilAPI
    var buscarUf = function(cepLimpo) {
        return fetch("https://viacep.com.br/ws/" + cepLimpo + "/json/")
            .then(function(r) { return r.json(); })
            .then(function(d) {
                if (d && !d.erro && d.uf) return d.uf;
                throw new Error("viacep sem resultado");
            })
            .catch(function() {
                return fetch("https://brasilapi.com.br/api/cep/v1/" + cepLimpo)
                    .then(function(r) { return r.ok ? r.json() : null; })
                    .then(function(d) { return d && d.state ? d.state : null; });
            });
    };

    var calculateShipping = function() {
        if (calculando) return;
        var cepLimpo = shippingZip.value.replace(/\D/g, "");

        if (cepLimpo.length !== 8) {
            showError("Por favor, digite um CEP válido com 8 dígitos.");
            return;
        }

        shippingMessage.innerHTML = "";
        shippingMessage.setAttribute("style", "display:none");
        freteLista.innerHTML = "";

        buscarUf(cepLimpo)
            .then(function(uf) {
                if (!uf) {
                    showError("CEP não encontrado, tente novamente.");
                    return;
                }

                shippingProvince.value = ufMap[uf] || uf;

                var variantId = parseInt(productSelect.value);
                if (!variantId) {
                    showError("Por favor, selecione uma variante do produto.");
                    return;
                }

                currentVariantId = variantId;
                getRates(variantId);
            })
            .catch(function(error) {
                showError("Erro ao validar CEP. Tente novamente.");
                log(error);
            });
    };

    var showError = function(message) {
        freteLista.innerHTML = "";
        freteLista.setAttribute("style", "display:none");
        shippingMessage.innerHTML = message;
        shippingMessage.setAttribute("style", "display:flex");
    };

    var atualizarBadge = function() {
        return fetch("/cart.js")
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                if (window.theme && window.theme.updateCartBadge) {
                    window.theme.updateCartBadge(cart.item_count);
                }
            })
            .catch(function() {});
    };

    // Devolve o carrinho exatamente como estava (quantidade anterior do item)
    var restaurarCarrinho = function(variantId, qtdAnterior, adicionou) {
        if (!adicionou) return Promise.resolve();
        return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: String(variantId), quantity: qtdAnterior })
        })
        .catch(function(err) { log("Erro ao restaurar carrinho: " + err); })
        .then(atualizarBadge);
    };

    var params = function() {
        return new URLSearchParams({
            "shipping_address[country]": shippingCountry.value,
            "shipping_address[province]": shippingProvince.value,
            "shipping_address[zip]": shippingZip.value
        });
    };

    // Método assíncrono da Shopify: espera as transportadoras (apps de frete) responderem,
    // em vez de falhar com erro 500 quando elas demoram.
    var buscarFretes = function() {
        var p = params().toString();
        var inicio = Date.now();

        return fetch("/cart/prepare_shipping_rates.json?" + p, { method: "POST" })
            .then(function(r) {
                if (r.status === 422) {
                    return r.json().then(function(j) { throw { validacao: j }; });
                }
                return new Promise(function(resolve, reject) {
                    var tentar = function() {
                        fetch("/cart/async_shipping_rates.json?" + p)
                            .then(function(res) {
                                return res.text().then(function(t) { return { status: res.status, texto: t }; });
                            })
                            .then(function(res) {
                                if (res.status === 200 && res.texto && res.texto !== "null") {
                                    resolve(JSON.parse(res.texto));
                                } else if (Date.now() - inicio > RATES_TIMEOUT) {
                                    reject(new Error("timeout"));
                                } else {
                                    setTimeout(tentar, RATES_POLL_INTERVAL);
                                }
                            })
                            .catch(function() {
                                if (Date.now() - inicio > RATES_TIMEOUT) reject(new Error("falha"));
                                else setTimeout(tentar, RATES_POLL_INTERVAL);
                            });
                    };
                    setTimeout(tentar, 500);
                });
            })
            .catch(function(err) {
                if (err && err.validacao) throw err;
                // Última tentativa pelo método antigo
                return fetch("/cart/shipping_rates.json?" + p).then(function(r) {
                    if (!r.ok) throw new Error("status " + r.status);
                    return r.json();
                });
            });
    };

    var montarLista = function(data) {
        freteLista.innerHTML = "";

        if (!(data && data.shipping_rates && data.shipping_rates.length)) {
            freteLista.innerHTML = "<p>Nao encontramos fretes disponiveis para este CEP.</p>";
            return;
        }

        var prazoJadlog = null;
        for (var j = 0; j < data.shipping_rates.length; j++) {
            var nomeFrete = data.shipping_rates[j].name;
            if (nomeFrete.indexOf("Jadlog") !== -1 && nomeFrete.indexOf("Frete Fixo") === -1) {
                var dd = data.shipping_rates[j].delivery_days;
                var dt = data.shipping_rates[j].delivery_date;
                if (dd && dd.length > 0 && dd[dd.length - 1] != null) {
                    prazoJadlog = "Até " + dd[dd.length - 1] + " dias úteis";
                } else if (dt) {
                    var dDate = new Date(dt);
                    var hoje = new Date();
                    var diff = Math.ceil(Math.abs(dDate - hoje) / (1000 * 60 * 60 * 24));
                    prazoJadlog = "Até " + diff + " dias úteis";
                }
                break;
            }
        }

        for (var i = 0; i < data.shipping_rates.length; i++) {
            var rate = data.shipping_rates[i];
            var entrega = "Estimativa de entrega indisponível";

            if (rate.delivery_days && rate.delivery_days.length > 0 && rate.delivery_days[rate.delivery_days.length - 1] != null) {
                entrega = "Até " + rate.delivery_days[rate.delivery_days.length - 1] + " dias úteis";
            } else if (rate.delivery_date) {
                var deliveryDate = new Date(rate.delivery_date);
                var today = new Date();
                var diffDays = Math.ceil(Math.abs(deliveryDate - today) / (1000 * 60 * 60 * 24));
                entrega = "Até " + diffDays + " dias úteis";
            } else if (prazoJadlog) {
                entrega = prazoJadlog;
            }

            var valorFrete = rate.price;
            if (valorFrete == "0.00" || valorFrete == null || valorFrete == 0 || valorFrete === "0") {
                valorFrete = "Gratis";
            } else {
                valorFrete = "R$ " + parseFloat(valorFrete).toFixed(2).replace(".", ",");
            }

            var freteItem = document.createElement("div");
            freteItem.className = "frete-item";
            freteItem.innerHTML = '<div><p class="m-0 nome-frete"><b></b><span class="estimativa-de-entrega"></span></p></div><div class="frete-valor">Valor: <b></b></div>';
            freteItem.querySelector(".nome-frete b").textContent = rate.name;
            freteItem.querySelector(".estimativa-de-entrega").textContent = entrega;
            freteItem.querySelector(".frete-valor b").textContent = valorFrete;
            freteLista.appendChild(freteItem);
        }
    };

    var getRates = function(variantId) {
        calculando = true;
        freteLista.innerHTML = '<div style="display:flex;align-items:center;gap:8px"><img id="loading-icon-frete" src="https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543" width="30" height="30" alt=""><span>Calculando frete...</span></div>';
        freteLista.setAttribute("style", "display:block");

        // Garante interceptação antes de qualquer fetch
        interceptarOpenMiniCart();
        window.__calculandoFrete = true;

        var qtdAnterior = 0;
        var adicionou = false;

        fetch("/cart.js")
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                // Se o produto já está no carrinho, calcula sem mexer nele
                for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].variant_id === variantId) {
                        qtdAnterior += cart.items[i].quantity;
                    }
                }
                if (qtdAnterior > 0) return null;
                adicionou = true;
                return fetch("/cart/add.js?upcart=1&opens_cart=never", {
                    body: JSON.stringify({ id: variantId, quantity: 1 }),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    method: "POST"
                }).then(function(r) {
                    if (!r.ok) { adicionou = false; throw new Error("add " + r.status); }
                    return r.json();
                });
            })
            .then(function() { return buscarFretes(); })
            .then(function(data) {
                montarLista(data);
            })
            .catch(function(error) {
                log(error);
                if (error && error.validacao) {
                    showError("CEP inválido para entrega. Confira e tente novamente.");
                } else {
                    showError("Não foi possível calcular o frete agora. Tente novamente em instantes.");
                }
            })
            .then(function() {
                return restaurarCarrinho(variantId, qtdAnterior, adicionou);
            })
            .then(function() {
                window.__calculandoFrete = false;
                calculando = false;
            });
    };

    initFields();
})();
